
// import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI, {Message} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//import './assets/theme/theme-green/index.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import Particles from 'vue-particles'
//import Particles from "vue2-particles";
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
import routes from './routes'
// import Mock from './mock'
import qs from 'qs'
import '@/common/js/permission'
import './assets/css/image_css.css'
import './assets/css/icon-size.css'
import './assets/css/tabelname.css'
import './assets/css/global.css'
import './assets/css/seachCss.css'
// Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'
import tableMove from "./utils/tableMove";
import searchLoading from'./loading/searchLoaing.vue'
import customerAddress from './views/customerMag/CustomerAddress.vue'
import addressSelector from './views/customerMag/addressSelector.vue'
import '../src/model/menus.js'
import { v4 as uuidv4 } from 'uuid'; // 导入用于生成 UUID 的库
//权限指令
// import '@/common/js/permission'
//百度地图
import BaiduMap from 'vue-baidu-map'
import globalComponents from './components'
import {formatTime,formatTimeNew,formatTimeYYYY} from "./utils/timeFormatter";
import LoadingPage from './loading/orderRecreatingLoading.vue'
import ProductSelect from "./views/order/productSelect.vue";
import searchUtils from "./utils/searchUtils";
import CountTo from 'vue-count-to'
import scrollPosition from "./utils/scrollPosition";
//地区选择器
Vue.prototype.$formatDateTime = formatTime;
Vue.prototype.$scrollPos=scrollPosition;
Vue.prototype.$formatTimeNew = formatTimeNew;
Vue.prototype.$formatTimeYYYY = formatTimeYYYY;
Vue.prototype.$searchUtils = searchUtils;
Vue.use(BaiduMap, {
  ak: 'abhCTURfZ4jIP1nopcOBhaRd323M0UlT'
})
//引入axios
import axios from 'axios'
// token存储优化：将JWT直接存储在内存中，避免localStorage存储过大的数据
//配置axios的全局基本路径，访问后端接口使用8080
//axios.defaults.baseURL = 'http://localhost:8080/'
//axios.defaults.baseURL = 'http://119.29.157.10:8080/'
//axios.defaults.baseURL = 'http://116.198.243.174:8080/'
//axios.defaults.baseURL = 'http://8.140.22.136:8080/'
 // axios.defaults.baseURL='https://www.kongqichong.com:8080//'
  axios.defaults.baseURL='/api'
//全局属性配置，在任意组件内可以使用this.$http获取axios对象
Vue.prototype.$http = axios
Vue.prototype.$qs = qs
//列表显示图片的前缀
 Vue.prototype.imgPrefix="https://www.kongqichong.com:8888"
 Vue.component('LoadingPage',LoadingPage)
 Vue.component('SearchLoading',searchLoading)
 Vue.component('ProductSelect',ProductSelect)
 Vue.component('customerAddress',customerAddress)
 Vue.component('addressSelector',addressSelector)
 Vue.component('count-to', CountTo)

//文件上传路径
 Vue.prototype.$uploadURL = "https://www.kongqichong.com/api/minio/upload";
 //Vue.prototype.$uploadURL = '/api/minio/upload';
//Vue.prototype.$uploadURL = "http://localhost:8080/minio/upload";

Vue.prototype.$projectName = "空气虫管理系统";
Vue.prototype.$message = Message
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(globalComponents)
Vue.use(Particles)
Vue.use(tableMove)


//Vue.use(Particles)
//NProgress.configure({ showSpinner: false });

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//1.axios前置拦截器：每次通过axios发送请求之前，让所有的请求都携带uToken
axios.interceptors.request.use(res => {
  //携带精简的token（后端只验证身份，不包含菜单权限）
  let uToken = localStorage.getItem("token");
  if (uToken) {
    res.headers['token'] = uToken;
  }
  // 只为 PUT 和 POST 请求添加 Idempotency-Key
  // if (res.method === 'put' || res.method === 'post') {
  //   const idempotencyKey = uuidv4(); // 生成唯一的 Idempotency-Key
  //   res.headers['Idempotency-Key'] = idempotencyKey; // 添加 Idempotency-Key 到请求头
  // }
  return res;
}, error => {
  Promise.reject(error);
})
let isLogoutPromptShowing = false;
//2.axios后置拦截器：后端处理完axios请求之后，处理响应的数据
//发送axios请求之后都会执行以下代码
axios.interceptors.response.use(res => {
  if (false === res.data.success && "noLogin" === res.data.msg) {

    //清除localStorage中的所有登录信息
    localStorage.removeItem("token");
    localStorage.removeItem("has_login");
    localStorage.removeItem("logininfo");
    localStorage.removeItem("menus");
    localStorage.removeItem("permissions");
    localStorage.removeItem("lastCustomerId");
    // 如果当前没有显示登录失效提示，则显示
    if (!isLogoutPromptShowing) {
      isLogoutPromptShowing = true;
      // 显示登录失效的提示信息
      Message({
        type: 'warning',
        message: '当前登录已失效，稍后将重新登录',
        duration: 3000, // 显示时间
        onClose: () => {
          // 跳转到登录页面
          router.push({ path: '/login' });
        }
      })};
  } else if(false === res.data.success && "timeout" === res.data.msg){
    //清除localStorage中的所有登录信息
    localStorage.removeItem("token");
    localStorage.removeItem("has_login");
    localStorage.removeItem("logininfo");
    localStorage.removeItem("menus");
    localStorage.removeItem("permissions");
    localStorage.removeItem("lastCustomerId");
    //跳转到登录页面
    router.push({path: '/login'});
    // 显示超时的提示信息
    Message({
      type: 'warning',
      message: '当前登录超时，3秒后重新登录',
      duration: 3000, // 显示时间
      onClose: () => {
        // 跳转到登录页面
        router.push({ path: '/login' });
      }
    });
  }
  return res;
},error => {
  Promise.reject(error)
})
//3.路由前置拦截器 - 拦截非axios请求
router.beforeEach((to, from, next) => {
  //如果访问登录页面   或  注册页面
  if (to.path == '/login' || to.path == "/shopRegister") {
    next();//放行
  }else{//其他页面都需要判断你是否登录过
    //检查登录状态
    let hasLogin = localStorage.getItem('has_login');
    let token = localStorage.getItem('token');
    if (hasLogin && token) {
      // 如果访问根路径，重定向到第一个有权限的子路由
      if (to.path === '/') {
        const menus = JSON.parse(localStorage.getItem('menus') || '[]');
        if (menus.length > 0 && menus[0].children && menus[0].children.length > 0) {
          const firstRoute = menus[0].children[0].url;
          next(firstRoute);
          return;
        }
      }
      next(); //登录过放行
    } else {
      next({path: '/login'});//跳转到login - 登录页面
    }
  }
})
//处理页面刷新动态路由失效问题
initIndexRouters();
function initIndexRouters() {
  if (!localStorage.menus) return;
  if (router.options.routes.length > 20) return;

  let menus;
  try {
    // 安全解析localStorage中的menus
    const menusStr = localStorage.getItem('menus');
    if (!menusStr) return;

    // 检查是否已经是对象
    if (typeof menusStr === 'object') {
      menus = menusStr;
    } else {
      // 尝试解析JSON字符串
      menus = JSON.parse(menusStr);
    }
  } catch (error) {
    console.error('解析menus失败:', error);
    return;
  }

  let tempRouters = [];

  // 确保menus是数组
  if (!Array.isArray(menus)) {
    console.error('menus不是数组格式:', menus);
    return;
  }

  menus.forEach(menu => {
    // 验证menu对象的基本属性
    if (!menu || !menu.name) {
      console.warn('跳过无效的菜单项:', menu);
      return;
    }

    let indexRouter = {
      path: '/',
      iconCls: menu.icon || '',
      name: menu.name,
      component: resolve => require(['@/views/Home'], resolve),
      children: []
    }

    // 确保children存在且为数组
    const children = menu.children || [];
    if (!Array.isArray(children)) {
      console.warn('菜单children不是数组:', menu.name, children);
      return;
    }

    children.forEach(cMenu => {
      // 验证子菜单项
      if (!cMenu || !cMenu.name || !cMenu.component) {
        console.warn('跳过无效的子菜单项:', cMenu);
        return;
      }

      let cr = {
        path: cMenu.url || '',
        name: cMenu.name,
        component: resolve => require(['@/views/' + cMenu.component], resolve),
        meta: {
          cacheable: true, // 标记为可缓存
          cacheKey: cMenu.component.replace(/\//g, '-'), // 生成唯一缓存key
          keepAlive: true // 启用keep-alive
        }
      }
      indexRouter.children.push(cr)
    })

    tempRouters.push(indexRouter)
    router.options.routes.push(indexRouter)
  })

  router.addRoutes(tempRouters);
}
new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js